import React from "react";
import { NavLink } from "react-router-dom";

import PageLayout from "components/layout/PageLayout";

const MENU = [
  ["/settings", "Profile"],
  ["/settings/password", "Password"],
  ["/transactions", "Order history"],
];

function ChevronRight() {
  return (
    <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
      <path d="M7.5 5l5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Account pages in univ.mekari.com's layout: one white card with the
// account menu on the left and the page on the right.
export default function AccountLayout({ title, children }) {
  return (
    <PageLayout className="yc-app--grey">
      <div className="yc-container">
        <div className="yc-account">
          <nav className="yc-account-menu" aria-label="Account">
            {MENU.map(([to, label]) => (
              <NavLink key={to} exact to={to} activeClassName="is-active">
                {label}
                <ChevronRight />
              </NavLink>
            ))}
          </nav>
          <main className="yc-account-main">
            <h1 className="yc-account-title">{title}</h1>
            {children}
          </main>
        </div>
      </div>
    </PageLayout>
  );
}
